import * as React from 'react';
import { getSearchUrlWithParams, getUpcomingTitleSearchParams } from '@/utils/urls';
import {
    PopoverContentContainer,
    PopoverMenuItem,
    PopoverWrapper,
    StyledIcon,
    StyledLink,
    StyledPopover,
    StyledSubMenuText,
    TriggerWrapper,
} from './helpers/styles';
import { useDispatch, useSelector } from 'react-redux';
import { faEllipsisV } from '@fortawesome/pro-light-svg-icons/faEllipsisV';
import { FormattedMessage } from 'react-intl';
import { getItem } from '@/redux/modules/item';
import isEqual from 'react-fast-compare';
import { openExcludeHouseModal } from '@/redux/modules/modal';
import { submitSaveSearch } from '@/redux/modules/saveSearch';
import { toast } from 'react-toastify';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';

type Props = {
    itemId: number;
};

const ItemCardMenu = ({ itemId }: Props) => {
    const dispatch = useDispatch();
    const { sellerId, title } = useSelector((state) => getItem(state, itemId), isEqual);
    const isMobile = useIsNarrowerThan(761);

    const showConfirmExcludeModal = React.useCallback(() => {
        dispatch(openExcludeHouseModal(sellerId));
    }, [dispatch, sellerId]);

    const saveSearchParams = getUpcomingTitleSearchParams(title);
    saveSearchParams.status = 'online';
    const itemSearchKeyword = saveSearchParams?.keyword;

    const toggleSearchAlert = React.useCallback(() => {
        dispatch(submitSaveSearch(saveSearchParams, true));
        const toastMessage = "Following search! We'll send you email alerts for similar items.";
        toast(toastMessage, { autoClose: 5000 });
    }, [dispatch, saveSearchParams]);

    return (
        <PopoverWrapper>
            <StyledPopover
                childrenClickClosesPopover
                click
                hover={false}
                placement={isMobile ? 'bottom' : 'left'}
                showArrow={false}
                trigger={
                    <TriggerWrapper>
                        <StyledIcon icon={faEllipsisV} />
                    </TriggerWrapper>
                }
            >
                <PopoverContentContainer>
                    <PopoverMenuItem>
                        <StyledLink
                            route
                            to={getSearchUrlWithParams({
                                keyword: itemSearchKeyword,
                                page: 1,
                                status: 'online',
                            })}
                        >
                            <StyledSubMenuText>
                                <FormattedMessage id="search_see_similar" />
                            </StyledSubMenuText>
                        </StyledLink>
                    </PopoverMenuItem>
                    <PopoverMenuItem onClick={toggleSearchAlert}>
                        <StyledSubMenuText>
                            <FormattedMessage id="search_create_alert" />
                        </StyledSubMenuText>
                    </PopoverMenuItem>
                    <PopoverMenuItem onClick={showConfirmExcludeModal}>
                        <StyledSubMenuText>
                            <FormattedMessage id="search_exclude_this_auction_house" />
                        </StyledSubMenuText>
                    </PopoverMenuItem>
                </PopoverContentContainer>
            </StyledPopover>
        </PopoverWrapper>
    );
};

export default ItemCardMenu;
